<template>
  <b-container fluid="true">
    <b-navbar toggleable="lg">
      <b-navbar-toggle target="nav-collapse">
        <font-awesome-icon icon="bars" size="1x" />
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" class="collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item
            :to="{ name: 'profile' }"
            :class="{ 'is-active': subIsActive('/profile') }"
            class="text-lg-center"
          >
            <font-awesome-icon icon="user-circle" size="1x" />

            <span class="d-inline d-sm-inline d-lg-block d-xl-inline">{{
              $t("header.my_account")
            }}</span>
          </b-nav-item>

          <!-- ???: ?? -->
          <!-- <b-nav-item class="text-lg-center d-flex justify-content-lg-center">
            <div v-if="networkStatus == true" class="center d-flex justify-content-lg-center h-100">
              <font-awesome-icon icon="signal" size="1x" />
              <div class="online"></div>
            </div>
            <div v-else class="center d-flex justify-content-center h-100">
              <font-awesome-icon icon="signal" size="1x" />
              <div class="offline"></div>
            </div>
          </b-nav-item> -->

          <div v-if="showSyncingIndicatorInHeader" class="sync-indicator">
            <font-awesome-icon v-if="showSyncLoading" icon="sync-alt" class="text-light" pulse />
            <font-awesome-icon
              v-else-if="showSyncLoadingSuccess"
              icon="check-circle"
              class="text-success"
            />
            <font-awesome-icon
              v-else-if="showSyncLoadingError"
              icon="times-circle"
              class="text-danger"
            />
            <font-awesome-icon
              v-else
              icon="sync-alt"
              class="text-light sync-button"
              title="sync"
              @click="startSyncing"
            />
          </div>

          <!-- TODO: Mercure live changes indicator -->
          <!-- <font-awesome-icon icon="cloud" class="text-light" />
          <font-awesome-icon icon="spinner" class="text-light" pulse /> -->

          <!-- TEST: .. -->
          <!-- <b-nav-item :to="{ name: 'db' }" class="text-md-center">
            <font-awesome-icon icon="vial" size="1.2x" />
            <span class="d-inline">
              Tests
            </span>
          </b-nav-item> -->
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <!-- <b-nav-item
          :to="{ name: 'home' }"
          :class="{ 'is-active': subIsActive('/') && $route.name == 'home' }"
          class="text-md-center border-md-none"
        >
          <font-awesome-icon icon="home" size="1.2x" />
          <span class="d-inline">{{ $t("header.home") }}</span>
        </b-nav-item> -->

          <b-nav-item
            :to="{ name: 'home' }"
            :class="{ 'is-active': subIsActive('/') && $route.name == 'home' }"
            class="text-lg-center border-md-none"
          >
            <font-awesome-icon icon="home" size="1x" />
            <span class="d-inline d-sm-inline d-lg-block d-xl-inline">{{
              $t("header.tableau_au_bord")
            }}</span>
          </b-nav-item>

          <b-nav-item
            :to="{ name: 'catalogs' }"
            :class="{ 'is-active': subIsActive('/catalogs') }"
            class="text-lg-center"
          >
            <font-awesome-icon icon="folder" size="1x" />
            <span class="d-inline d-sm-inline d-lg-block d-xl-inline">{{
              $t("header.catalogs")
            }}</span>
          </b-nav-item>
          <b-nav-item
            :to="{ name: 'meetings' }"
            :class="{ 'is-active': subIsActive('/meetings') }"
            class="text-lg-center"
          >
            <font-awesome-icon icon="user-friends" size="1x" />
            <span class="d-inline d-sm-inline d-lg-block d-xl-inline">{{
              $t("header.meetings")
            }}</span>
          </b-nav-item>
          <b-nav-item
            :to="{ name: 'configurations' }"
            :class="{ 'is-active': subIsActive('/configurations') }"
            class="text-lg-center"
          >
            <font-awesome-icon icon="cog" size="1x" />
            <span class="d-inline d-sm-inline d-lg-block d-xl-inline">{{
              $t("header.configurations")
            }}</span>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </b-container>
</template>

<script>
import syncEngineMixins from "@/mixins/sync-engine";

export default {
  mixins: [syncEngineMixins],
  data() {
    return {};
  },
  methods: {
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    // FIXME: renounce $parent ..
    redirectToMeeting() {
      this.$router.push({
        params: {
          id: this.$parent.meeting.id,
        },
        name: "meeting-start",
      });
    },
    // TODO: additional checkings
    startSyncing() {
      this.syncEngineFunction();
    },
  },
};
</script>

<style scoped>
.online {
  width: 10px;
  height: 10px;
  top: -5px;
  border-radius: 50%;
  background-color: #29a847;
  margin: auto;
}

.offline {
  width: 10px;
  height: 10px;
  top: -5px;
  border-radius: 50%;
  background-color: red;
  margin: auto;
}

.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:focus {
  color: white !important;
}
</style>
